<template>
    <div class="row" v-if="!isLoggedIn">
        <div class="col-sm-12 col-lg-6 offset-sm-0 offset-lg-3">
            <form
                @submit="onSubmit"
                action=""
                class="form-horizontal"
                method="post"
                name="form"
                novalidate=""
                ref="loginForm"
            >
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header card-header">
                            <h5 class="modal-title">Login</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-3 text-center">
                                    <card-account-details-outline-icon
                                        class="largeIcon"
                                    ></card-account-details-outline-icon>
                                </div>
                                <div class="col-sm-9">
                                    <div class="form-group">
                                        <label for="username">User name</label>
                                        <input
                                            autocomplete="username"
                                            class="form-control"
                                            id="username"
                                            maxlength="147"
                                            placeholder="Enter Username"
                                            required
                                            type="text"
                                            v-model="user.username"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <label for="password">Password</label>
                                        <input
                                            autocomplete="current-password"
                                            class="form-control"
                                            id="password"
                                            maxlength="147"
                                            placeholder="Password"
                                            required
                                            type="password"
                                            v-model="user.password"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer card-header">
                            <button
                                @click.prevent="onSubmit"
                                class="btn btn-primary"
                                type="submit"
                            >
                                Login
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import CardAccountDetailsOutlineIcon from "vue-material-design-icons/CardAccountDetailsOutline";

export default {
    components: { CardAccountDetailsOutlineIcon },
    props: {
        api_error: { type: Object, default: () => "" },
    },

    data() {
        return {
            // the current data entered into the form
            user: {
                username: "",
                password: "",
            },
            dialog: {},
        };
    },
    computed: {
        ...mapGetters("AuthModule", ["isLoggedIn"]),
        _se() {
            // Return an empty Object if there are no Server Errors to avoid Binding Errors
            return this.serverErrors || {};
        },
    },
    methods: {
        onSubmit() {
            this.$emit("submitted", this.user);
        },

        onCancel() {
            this.$emit("cancelled");
        },
    },
};
</script>
<style>
.largeIcon {
    width: 100px !important;
    height: 100px !important;
}

.largeIcon > .material-design-icon__svg {
    width: 100px !important;
    height: 100px !important;
}
</style>
